import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select';
import Multiselect from 'vue-multiselect';

export default {
  name: 'SorterBatchStatus',
  components: {
    Paginate,
    VueElementLoading,
    BasicSelect,
    Multiselect
  },
  props: [],
  data() {
    return {
      isLoading: false,
      BatchId: '',
      currentHubId:'',
      BatchIdDetails: [],
      UpdateStatusModal: false,
      useremail:'',
      totalRows:0,
			pageNo: 0,
			limit: 10,
      pageCount: 0,
      batchId: '',
      hublist:[],
			hubitem: {
				value: '',
				text: ''
			},
			hub: '',
			hubzonelist: [],
			hubzoneitem: {
				id: '',
				text: ''
			},
			hubzone:'',
			hubzoneLoading: '',
			hubLoading:'',
      hubObj:[]
    }
  },
  computed: {},
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY HH:mm:ss');
    },
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.useremail = userdetail[0].email;
    this.currentHubId=userdetail[0].HubId[0] == undefined ? 0 : userdetail[0].HubId[0]
    this.getHubZone();
  },
  methods: {
    getHubZone() {
			this.hubzoneLoading = 'Loading Hub Zone...'
			var i = 0;
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				// hubName: this.hubzoneitem.id,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubzone/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubzoneLoading = ''
					this.HubZoneListData = result.data.ResponseData;
					for (i = 0; i < this.HubZoneListData.length; i++) {
						this.hubzonelist.push({
							id: this.HubZoneListData[i].hubzoneid,
							text: this.HubZoneListData[i].hubzonename
						})
					}
				}, error => {
					console.error(error)
				})
		},
		selectHubZone(hubzoneitem) {
			this.hubzoneitem = hubzoneitem
			this.hubzone = this.hubzoneitem.id
      this.hubObj=[]
      this.$validator.reset('Hub')
			if (this.hubzone != undefined) {
				this.getHubList(this.hubzone)
			}
		},
		getHubList(data) {
			this.hubLoading = 'Loading Hub...'
			this.hublist = []
			this.hubitem={
				value:'',
				text:''
			}
			this.hub=''
			this.input = ({hubZoneId: data})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then(result => {
					this.hubLoading=''
					var HubDetails = result.data.ResponseData
					for (var i = 0; i < HubDetails.length; i++) {
						this.hublist.push({
							"value": HubDetails[i].HubID,
							"text": HubDetails[i].HubName + '(' + HubDetails[i].HubID + ')',
						})
					}
				}, error => {
					console.error(error)
				})
		},
    selectHub(hubitem) {
			this.hubitem = hubitem
			this.hub = hubitem.value
		},
    getBatchDetails() {
      this.BatchIdDetails = []
      this.isLoading = true
      axios({
    			method: 'GET',
    			'url': apiUrl.api_url_hubops + `getBatchDetailsByHubId?currentHubId=${this.hub}&createdBy=${this.useremail}&batchId=${this.BatchId}&status=InProcess&pageNo=${this.pageNo}&pageSize=${this.limit}`,
    			headers: {
    				'authorization': 'authkey xB84JJ89Hd25',
    			}
    		})
        .then(result => {
          this.isLoading = false
          if (result.data.ResultCode == 100) {
            this.BatchIdDetails = result.data.ResponseData

            this.totalRows = result.data.TotalCount
    				if (this.totalRows < 10) {
    					this.pageCount = 1
    				} else {
    					this.pageCount = Math.ceil(this.totalRows / 10);
    				}
          } else {
            this.BatchIdDetails = []
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.isLoading = false;
          console.error(error)
        })
    },
    getPaginationData(pageNum) {
   	 this.pageNo = (pageNum - 1)
   	 this.getBatchDetails()
    },
    openUpdateStatusModal(data) {
      this.batchId = '';
      this.UpdateStatusModal = true;
      this.batchId = data.batchId;
    },
    closeUpdateStatusModal() {
      this.UpdateStatusModal = false
    },
    updateStatus() {
      this.input = {
        currentHubId: this.hub,
        batchId: this.batchId,
        status: 'InProcess'
      }
      axios({
          'method': 'POST',
          'url': apiUrl.api_url_hubops + 'updateBatchStatus',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.$alertify.success(result.data.ReturnMessage)
            this.closeUpdateStatusModal();
            this.getBatchDetails();
          } else {
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          console.error(error)
        })
    },
    resetForm() {
      this.isLoading = false
      this.BatchId = ''
      this.BatchIdDetails = []
      this.UpdateStatusModal= false
      this.totalRows=0;
			this.pageNo=0;
      this.batchId='';
      this.hubzoneitem={
        id: '',
				text: ''
      };
      this.hubitem={
        value: '',
				text: ''
      };
      this.hubzone='';
      this.hub='';
      this.hubObj=[];
      this.$validator.reset();
    },
    onSubmit: function() {
			var self = this
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				}else{
					this.getBatchDetails()
				}
			}).catch(() => {
				console.log('errors exist')
			});
		}
  }
}



// WEBPACK FOOTER //
// ./src/views/components/SorterBatchStatus/SorterBatchStatus.js